var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyDefaultLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 4,
    fill: "#EDF1F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "company-default-logo_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#company-default-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.52 22.166c1.183-1.315 2.48-3.22 2.48-7.134s-1.745-5.676-1.745-5.676l-.58-.678-14.29-16.515a5.57 5.57 0 00-1.722-1.346 5.482 5.482 0 00-4.25-.285c-.692.24-1.33.615-1.88 1.106l-.055.051a5.643 5.643 0 00-1.318 1.754 5.731 5.731 0 00.82 6.232L29.586 11.95a4.552 4.552 0 011.169 3.021 4.22 4.22 0 01-.347 1.702 4.154 4.154 0 01-1 1.408L17.052 29.622a5.73 5.73 0 00-1.375 4.1 5.704 5.704 0 001.873 3.89l.06.051a5.503 5.503 0 004.026 1.4 5.527 5.527 0 003.82-1.907l16.063-14.99z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.346 21.843c-.96 1.07-2.013 2.621-2.013 5.806s1.416 4.619 1.416 4.619l.471.552 11.601 13.44c.39.455.866.827 1.398 1.095a4.442 4.442 0 004.975-.668l.045-.042c.445-.399.809-.884 1.07-1.427a4.672 4.672 0 00.22-3.518 4.623 4.623 0 00-.886-1.553l-8.609-9.99a3.71 3.71 0 01-.95-2.459 3.441 3.441 0 01.283-1.384c.188-.436.465-.827.812-1.146l10.029-9.392a4.67 4.67 0 001.116-3.337 4.646 4.646 0 00-1.52-3.165l-.049-.042a4.46 4.46 0 00-3.268-1.139 4.483 4.483 0 00-3.101 1.551l-13.04 12.199z",
    fill: "#EBEBED"
  }))));
}
export default __webpack_public_path__ + "static/media/company-default-logo.e96358b0.svg";
export { SvgCompanyDefaultLogo as ReactComponent };